export default "__VITE_ASSET__lcL$_m3I__"